export default class Accordion {
  constructor(element) {
    this.trigger = element.querySelector('.js-accordion-trigger');

    this.init();
  }

  init() {
   this.trigger.addEventListener('click', this.handleClick);
  }

  handleClick = () => {
   const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';

	this.trigger.setAttribute('aria-expanded', !isOpen);
  }
}
